import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareLinesBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareLinesBottom"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 15.5H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 15.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 11.5H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 11.5H17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareLinesBottom;
